import en from './en.json'
import de from './languages/de.json'
import nl from './languages/nl.json'

export { en, de, nl }
